import './PackageInfoCard.css'

import { useRef } from 'react'

import { getBrandLogo } from '../../../helpers/getBrandLogo'
import arrowDownIcon from '../../../imgs/down-arrow-blue.png'
import greeceFlagCircle from '../../../imgs/flags/greece-circle.png'
import ukFlagCircle from '../../../imgs/flags/uk-circle.png'
import usaFlagCircle from '../../../imgs/flags/usa-circle.png'
import contentIcon from '../../../imgs/package-info-card/content.svg'
import dimensionsIcon from '../../../imgs/package-info-card/dimmensions.svg'
import flammableIcon from '../../../imgs/package-info-card/flammable.svg'
import liquidIcon from '../../../imgs/package-info-card/liquid.svg'
import trackingIcon from '../../../imgs/package-info-card/track.svg'

const PackageInfoCard = ({ item }) => {
  const expandContRef = useRef(null)
  const getCountryFlag = country => {
    switch (country) {
      case 'GR':
        return greeceFlagCircle
      case 'USA':
        return usaFlagCircle
      case 'UK':
        return ukFlagCircle
    }
  }

  const getVolWeight = () => {
    let volWeight = (item.length * item.height * item.width) / 5000
    if (volWeight < 1) volWeight = 1
    return volWeight.toFixed(2)
  }

  const getContentCount = () => {
    const totalCount = item?.contents?.reduce((acc, c) => acc + +c.quantity, 0)
    return totalCount
  }

  const toggleExpand = () => {
    expandContRef.current.classList.toggle('package-info-card-expand-cont-active')
  }

  return (
    <div className='package-info-card' key={item.id}>
      <img src={getCountryFlag(item.warehouse)} alt={item.warehouse} className='pc-flag' />

      <div className='package-info-card-top'>
        <div className='package-info-card-brand-cont'>
          <img src={getBrandLogo(item.brand)} alt={item.brand} className='package-info-card-brand-img' />
          <div className='package-info-card-brand-title'>{item.brand.toUpperCase()}</div>
        </div>
      </div>

      <div className='package-info-card-content'>
        <div className='package-info-card-content-cube'>
          <span style={{ color: '#666666' }}> תאריך הגעה</span>{' '}
          <span style={{ fontSize: '14px' }}>{item.dateArrived.split('-').reverse().join('.')}</span>{' '}
        </div>
        <div className='package-info-card-content-cube'>
          <span style={{ color: '#666666' }}> משקל נפחי</span> <span style={{ fontSize: '14px' }}>{getVolWeight()}KG</span>
        </div>
        <div className='package-info-card-content-cube'>
          <span style={{ color: '#666666' }}> כמות</span> <span style={{ fontSize: '14px' }}>{getContentCount()} פריטים</span>
        </div>
        <img src={arrowDownIcon} alt='arrow' style={{ width: '16px', marginRight: 'auto' }} onClick={toggleExpand} />
      </div>

      <div className='package-info-card-expand-cont' ref={expandContRef}>
        <div className='package-info-card-expand-cont-inner'>
          <div className='package-info-card-expand-cont-item'>
            <div className='package-info-card-expand-cont-item-right'>
              <img src={trackingIcon} />
              <div className='package-info-card-expand-cont-item-title'>מספר מעקב</div>
            </div>
            <span>{item.trackingNumberInTurkey}</span>
          </div>
          <div className='package-info-card-expand-cont-item'>
            <div className='package-info-card-expand-cont-item-right'>
              <img src={dimensionsIcon} />
              <div className='package-info-card-expand-cont-item-title'>מידות</div>
            </div>
            <span>
              {item.length}x{item.height}x{item.width} ס"מ
            </span>
          </div>
          <div className='package-info-card-expand-cont-item'>
            <div className='package-info-card-expand-cont-item-right'>
              <img src={flammableIcon} />
              <div className='package-info-card-expand-cont-item-title'>פריטים דליקים</div>
            </div>
            <span>{item.isFlammable ? 'כן' : 'לא'}</span>
          </div>
          <div className='package-info-card-expand-cont-item'>
            <div className='package-info-card-expand-cont-item-right'>
              <img src={liquidIcon} />
              <div className='package-info-card-expand-cont-item-title'>מכיל נוזלים</div>
            </div>
            <span>{item.isLiquid ? 'כן' : 'לא'}</span>
          </div>
          <div className='package-info-card-expand-cont-item'>
            <div className='package-info-card-expand-cont-item-right'>
              <img src={contentIcon} />
              <div className='package-info-card-expand-cont-item-title'>פריטים בחבילה</div>
            </div>
            <span style={{ direction: 'ltr' }}>
              {item?.contents?.map((c, i) => {
                return (
                  <>
                    <span key={i}>
                      {c.quantity} {c.productCategory}
                      {i !== item.contents.length - 1 ? `, ` : ''}
                    </span>
                  </>
                )
              })}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PackageInfoCard
